<template>

  <section v-if="visible" v-show="loaded" class="container p-0">
    <div class="row">
      <div class="col-7 p-4 border-right auto-layout">
        <div class="row">
          <p v-show="!facOnly">
            <b>{{ currentContractStep }}</b>/{{ maxContractStep + ' ' + $t('overview.employee_action_2c') }}
          </p>
          <h1 style="word-break: break-word">{{ $t('employee.step_extension_' + currentContractStep) }}</h1>
        </div>

        <h5 v-if="contractData.employee">{{contractData.employee.first_name}} {{contractData.employee.prefix}} {{contractData.employee.last_name}}</h5>

        <div v-show="currentContractStep == 1" id="step-1">
          <div class="row">
            <label>{{ $t('employee.contract_type') }}</label>
            <fieldset class="btn-group" :data-field="contractData.job_function.fixed_term">
              <input id='ct1' type="radio" name="contract_type" class="btn-check" :value="1" v-model="contractData.job_function.fixed_term" @change="isValid" />
              <label for="ct1" class="btn btn-sm">{{$t('employee.contract_limited')}}</label>
              <input id='ct2' type="radio" name="contract_type" class="btn-check" :value="0" v-model="contractData.job_function.fixed_term" @change="isValid" />
              <label for="ct2" class="btn btn-sm">{{$t('employee.contract_unlimited')}}</label>
            </fieldset>
          </div>
          <div class="row">
            <label for="startdateinput">{{ $t('form.start_date') }}</label>
            <input type="date" id="startdateinput" v-model="contractData.job_function.start_date" :min="vroegsteStartdatum" @change="startdatumGewijzigd" />
            <small v-if="startdatumSluitNietAan" class="col-12 text-warning">
              Deze startdatum sluit niet aan op het vorige contract, dat liep tot en met {{ vorigeEinddatum }}. Controleer of dat de bedoeling is.
            </small>
          </div>
          <div class="row" v-if="contractData.job_function.fixed_term">
            <label for="enddate">{{ $t('form.end_months') }}</label>
            <select v-model="contractData.job_function.fixed_term_expiration_month" @change="setContractEndTime">
                <option value="0">Anders</option>
                <option v-for="n in 24" :value="n" :key="n">{{ n + ' ' + $tc('form.month', n) }}</option>
              </select>
          </div>
          <div class="row" v-if="contractData.job_function.fixed_term">
            <label for="enddateinput">{{ $t('form.end_date') }}</label>
            <input type="date" id="enddateinput" v-model="contractData.job_function.fixed_term_expiration_date" @change="isValid" :disabled="Number(contractData.job_function.fixed_term_expiration_month) > 0" />
          </div>

          <div class="row" v-if="showSkilledWorker">
            <label class="col-auto" :style="{width: '30%'}">{{ $t('employee.profession') }}</label>
            <fieldset class="col btn-group optional" :style="{'padding-left': '0.4rem', 'padding-right': '2.5rem'}" :data-field="contractData.job_function.skilled_worker">
              <input id='profession1' type="radio" name="profession" class="btn-check" :value="1" v-model="contractData.job_function.skilled_worker" />
              <label for="profession1" class="btn btn-sm">{{$t('employee.profession_1')}}</label>
              <input id='profession2' type="radio" name="profession" class="btn-check" :value="0" v-model="contractData.job_function.skilled_worker" />
              <label for="profession2" class="btn btn-sm">{{$t('employee.profession_2')}}</label>
              <input id='profession3' type="radio" name="profession" class="btn-check" :value="null" v-model="contractData.job_function.skilled_worker" />
              <label for="profession3" class="btn btn-sm">{{$t('employee.profession_3')}}</label>
            </fieldset>
          </div>

          <div class="row mb-3">
            <label>{{ $t('form.edit') }} (optioneel)</label>
            <div class="ps-1 pt-1">
              <input type="checkbox" v-model="editSchedule" @click="calculateTotalHours" @change="changeBack('editSchedule')" id="article-2">
              <label for="article-2" class="fw-bold d-inline">dienstverband / rooster</label>
              <br> <input type="checkbox" v-model="editSalary" @change="changeBack('editSalary')" id="article-1">
              <label for="article-1" class="fw-bold d-inline">salaris</label>
              <br> <input type="checkbox" v-model="editFunction" @change="changeBack('editFunction')" id="article-3">
              <label for="article-3" class="fw-bold d-inline">functie & afdeling</label>
              <br> <input type="checkbox" v-model="editCompensations" @change="changeBack('editCompensations')" id="article-5">
              <label for="article-5" class="fw-bold d-inline">overige vergoedingen</label>
            </div>
          </div>
          
          <div class="row" v-if="editSchedule">
            <label>{{ $t('employee.employment') }}</label>
            <fieldset class="btn-group" :data-field="contractData.job_function.employment_type">
              <input id='employment1' type="radio" name="employment" class="btn-check" value="fulltime" v-model="contractData.job_function.employment_type" @change="isValid" />
              <label for="employment1" class="btn btn-sm">{{$t('employee.employment_type_fulltime')}}</label>
              <input id='employment2' type="radio" name="employment" class="btn-check" value="hourly" v-model="contractData.job_function.employment_type" @change="isValid" />
              <label for="employment2" class="btn btn-sm">{{$t('employee.employment_type_hourly')}}</label>
              <input id='employment3' type="radio" name="employment" class="btn-check" value="internship" v-model="contractData.job_function.employment_type" @change="isValid" />
              <label for="employment3" class="btn btn-sm">{{$t('employee.employment_type_internship')}}</label>
            </fieldset>
          </div>
          <template v-if="editSchedule && (contractData.job_function.employment_type == 'fulltime' || contractData.job_function.employment_type == 'parttime')">
            <div class="row">
              <label>{{ $t('employee.roster_1') }}</label>
              <div>
                <div class="row employee-schedule">
                  <small class="col"></small>
                  <div class="col" v-for="weekday in weekdays" :key="weekday">{{weekday}}</div>
                </div>
                <div class="row employee-schedule">
                  <small class="col">Week 1</small>
                  <input type="number" class="col tiny-input" v-for="n in 5" :key="n" v-model="schedule[n-1]" @input="calculateTotalHours" @keydown="preventNonNumbers" @change="isValid" />
                  <input type="number" class="col tiny-input optional" v-for="n in 2" :key="n" v-model="schedule[4+n]" @input="calculateTotalHours" @keydown="preventNonNumbers" />
                </div>
                <div class="row employee-schedule mt-1">
                  <small class="col">Week 2</small>
                  <input type="number" class="col tiny-input" v-for="n in 5" :key="n" v-model="schedule[6+n]" @input="calculateTotalHours" @keydown="preventNonNumbers" @change="isValid" />
                  <input type="number" class="col tiny-input optional" v-for="n in 2" :key="n" v-model="schedule[11+n]" @input="calculateTotalHours" @keydown="preventNonNumbers" />
                </div>
              </div>
            </div>
            <div class="row mt-2" v-if="editSchedule">
              <label>{{ $t('employee.hours') }}</label>
              <div type="number" class="optional-disabled">{{getHoursCleaned(contractData.job_function.hours)}}</div>
            </div>
          </template>
          <div class="row salaryclass" v-if="editSalary">
            <label for="salary">
              {{ $t('employee.salary_' + (contractData.job_function.employment_type == 'hourly' ? 'hourly_simple' : (contractData.job_function.hours	== 38 ? 'fulltime' : 'parttime'))) }}
            </label>
            <input type="number" step="0.01" id="salary" v-model="contractData.job_function.salary" @change="isValid" />
          </div>
          <div class="row" v-if="editFunction">
            <label for="job-title">{{ $t('employee.job_title') }}</label>
            <select id="job-title" class="optional" v-model="contractData.job_function.debtor_function_id" @change="isValid">
              <option :value="null" disabled>{{ $t('form.select') }}</option>
              <option v-for="func in jobFunctions" :key="func.id" :value="func.id" @click="contractData.job_function.name = func.name">{{ func.name }}</option>
            </select>
          </div>
          <div class="row" v-if="editFunction">
            <label for="department">{{ $t('employee.department') }}</label>
            <select id="department" class="optional" v-model="contractData.job_function.debtor_department_id" @change="isValid">
              <option :value="null" disabled>{{ $t('form.select') }}</option>
              <option v-for="dep in jobDepartments" :key="dep.id" :value="dep.id" @click="contractData.job_function.department = dep.name">{{ dep.name }}</option>
            </select>
          </div>

          <template v-if="editCompensations">
            <div class="auto-layout">
              <div class="row comp-travel" v-if="editCompensations">
                <label class="ps-0 pt-1">{{$t('employee.comp_travel')}}</label>
                <fieldset class="btn-group ps-0" :data-field="contractData.job_function.travel_compensation_type">
                  <input id='tc1' type="radio" name="tc_type" class="btn-check" value="none" v-model="contractData.job_function.travel_compensation_type" @change="isValid($event); contractData.job_function.travel_compensation = null" />
                  <label for="tc1" class="btn btn-sm">{{$t('employee.travel_compensation_type_1')}}</label>
                  <!--<input id='tc2x' type="radio" name="tc_type" class="btn-check" value="distance" v-model="contractData.job_function.travel_compensation_type" @change="isValid($event); contractData.job_function.travel_compensation = '0.21'" />
                  <label for="tc2x" class="btn btn-sm">21 cent / km</label>-->
                  <input id='tc2' type="radio" name="tc_type" class="btn-check" value="distance" v-model="contractData.job_function.travel_compensation_type" @change="isValid($event); contractData.job_function.travel_compensation = '0.23'" />
                  <label for="tc2" class="btn btn-sm">{{$t('employee.travel_compensation_type_2')}}</label>
                  <input id='tc3' type="radio" name="tc_type" class="btn-check" value="monthly" v-model="contractData.job_function.travel_compensation_type" @change="isValid($event); contractData.job_function.travel_compensation = null" />
                  <label for="tc3" class="btn btn-sm">{{$t('employee.travel_compensation_type_3')}}</label>
                  <input id='tc4' type="radio" name="tc_type" class="btn-check" value="calculate" v-model="contractData.job_function.travel_compensation_type" @change="isValid($event); contractData.job_function.travel_compensation = null" />
                  <label for="tc4" class="btn btn-sm">{{$t('employee.travel_compensation_type_4')}}</label>
                </fieldset>
              </div>
            </div>
            <div class="auto-layout-3">
              <div class="row" v-if="editCompensations && contractData.job_function.travel_compensation_type == 'monthly'">
                <label></label>
                <div class="input-group">
                  <span>€</span> <input id="travelcomp-1" type="number" class="optional" v-model="contractData.job_function.travel_compensation" @change="isValid" />
                </div>
                <span>{{ $t('employee.per_month') }}</span>
              </div>
              <template v-else-if="contractData.job_function.travel_compensation_type == 'calculate'">
                <div class="row">
                  <label class="pe-0">{{$t('employee.travel_compensation_days')}}</label>
                  <div> <input id="travelcomp-2" type="number" v-model="contractData.job_function.travel_compensation_days" @change="isValid($event); calcTravelCompensation()" /> </div>
                </div>
                <div class="row">
                  <label>{{$t('employee.travel_compensation_distance')}}</label>
                  <div class="input-group">
                    <input id="travelcomp-3" type="number" v-model="contractData.job_function.travel_compensation_distance" @change="isValid($event); calcTravelCompensation()" />
                    <span class="w-25 p-2">km</span>
                  </div>
                </div>
                <div class="ms-1 ps-2">
                  {{ $t('employee.travel_compensation_calculated') + (contractData.job_function.travel_compensation ? contractData.job_function.travel_compensation.toFixed(2) : '-') }}
                </div>
              </template>
              <br>
            </div>
            <div class="auto-layout">
              <div class="row comp-travel">
                <label class="ps-0 pt-1">{{$t('employee.work_home_compensation')}}</label>
                <fieldset class="btn-group ps-0" :data-field="workHomeType">
                  <input id='whc1' type="radio" name="whc_type" class="btn-check" value="none" v-model="workHomeType" @change="isValid($event); setWorkHomeCompensation(false)" />
                  <label for="whc1" class="btn btn-sm">{{$t('employee.travel_compensation_type_1')}}</label>
                  <input id='whc2' type="radio" name="whc_type" class="btn-check" value="monthly" v-model="workHomeType" @change="isValid($event); setWorkHomeCompensation(true)" />
                  <label for="whc2" class="btn btn-sm">{{$t('employee.work_home_compensation_type_1')}}</label>
                  <input id='whc3' type="radio" name="whc_type" class="btn-check" value="calculate" v-model="workHomeType" @change="isValid($event); setWorkHomeCompensation(true)" />
                  <label for="whc3" class="btn btn-sm">{{$t('employee.work_home_compensation_type_2')}}</label>
                </fieldset>
              </div>
            </div>
            <div class="auto-layout-3">
              <div class="row" v-if="workHomeType == 'monthly'">
                <label></label>
                <div class="input-group">
                  <span>€</span> <input id="wcomp-1" type="number" v-model="contractData.job_function.work_days_at_home_compensation" @change="isValid" />
                </div>
                <span>{{ $t('employee.per_month') }}</span>
              </div>
              <template v-else-if="workHomeType == 'calculate'">
                <div class="row">
                  <label class="pe-0">{{$t('employee.work_home_compensation_days')}}</label>
                  <div> <input id="wcomp-2" type="number" v-model="contractData.job_function.total_work_days_at_home" @change="isValid($event); calcWorkHomeCompensation()" /> </div>
                </div>
                <div class="ms-1 ps-2">
                  {{ $t('employee.work_home_compensation_calculated') + (contractData.job_function.work_days_at_home_compensation ? Number(contractData.job_function.work_days_at_home_compensation).toFixed(2) : '-') }}
                </div>
              </template>
              <br>
            </div>
            <div class="auto-layout-3">
              <div class="row">
                <label for="travelcomp-2">{{$t('employee.comp_expenses')}}</label>
                <div class="input-group">
                  <span>€</span> <input id="travelcomp-2" type="number" class="optional" v-model="contractData.job_function.expenses_compensation" @change="isValid" />
                </div>
                <span>{{ $t('employee.per_month') }}</span>
              </div>
            </div>
            <div class="auto-layout-3">
              <div class="row">
                <label for="travelcomp-3">{{$t('employee.comp_phone')}}</label>
                <div class="input-group">
                  <span>€</span> <input id="travelcomp-3" type="number" class="optional" v-model="contractData.job_function.phone_compensation" @change="isValid" />
                </div>
                <span>{{ $t('employee.per_month') }}</span>
              </div>
            </div>
          </template>
        </div>

        <div v-show="currentContractStep == 2" id="step-2">
          <h5>{{ $t('employee.review_contract') }}</h5>
          <div v-html="templateHeader" class="mb-4"></div>
          <p class="fw-bold">Voeg hieronder eventuele toelichtingen toe:</p>
          <div id="pell" class="pell pell-short" />
          <div v-html="templateFooter" class="mt-4"></div>
        </div>
      </div>
      <div class="col-5 p-4">
        <div class="position-sticky" v-if="!facOnly">
          <h2>{{ $t('overview.employee_action_2c') }}</h2>
          <ol>
            <li :class="getListClass(1)">{{ $t('employee.step_extension_1') }}</li>
            <li :class="getListClass(2)">{{ $t('employee.step_extension_2') }}</li>
          </ol>
        </div>
      </div>
    </div>
    <div class="row justify-content-between">
      <div class="col-5 text-start">
        <button type="button" class="btn px-5 secondary-button" v-if="currentContractStep != 1" @click="onContractBack">{{ $t('form.back') }}</button>
      </div>
      <div class="col-7 text-end">
        <button type="button" class="btn px-5 action-button" @click="setNext" v-if="currentContractStep == 1">{{ $t('form.next') }}</button>
        <template v-else>
          <button type="button" class="btn px-5 action-button mx-3" @click="saveSection(3, 'download')" :disabled="isSaving"><i class="fa fa-download"></i>&ensp;{{ $t('overview.download_pdf') }}</button>
          <button type="button" class="btn px-5 btn-success" @click="saveSection(3, 'save')" :disabled="isSaving">{{ $t('employee.send_contract') }}</button>
        </template>
      </div>
    </div>
  </section>
  <i v-if="visible && !loaded" class="fa fa-spinner fa-spin fa-3x fa-fw mt-5"></i>

</template>

<script>
  import contractService from '@/services/ContractService'
  import employeeService from '@/services/EmployeeService'
  import fileService from '@/services/FileService'
  import store from '@/store/user'
  import pellCSS from 'pell/dist/pell.min.css'
  import moment from 'moment'
  import { vroegsteStartdatum as berekenVroegsteStartdatum, startdatumSluitAan, urenAlsTekst } from '@/logic/verlenging'
  import { metRem } from '@/logic/rem'
  import { alsTekst } from '@/logic/contracttekst'
  import { waarschuwingNaOpslaan } from '@/logic/meldingen'
  export default {
    name: 'EditExtension',
    props: ['visible', 'contractObject', 'nawObject', 'jobDepartments', 'jobFunctions', 'companyTemplates', 'attachments', 'companyAttachments', 'articles', 'loaded'],
    computed: {
      nawData: { get() { return this.nawObject } },
      contractData: { get() { return this.contractObject } },
      showContractNext() {return this.contractObject.generate_contract ? this.currentContractStep <= this.maxContractStep : this.currentContractStep < 2 },
      showSkilledWorker() { return window.currentCustomer && window.currentCustomer.use_skilled_worker },
      /*
       * De vroegste startdatum die een verlenging mag hebben.
       *
       * Het veld stond hard op disabled, waardoor een verlenging altijd aansloot op
       * de einddatum van het vorige contract. Als uitgangspunt is dat goed, maar als
       * die einddatum niet klopt is de verlenging structureel fout en was er geen weg
       * in het scherm om dat te corrigeren; bij Anna Zijp was de enige uitweg een
       * hardgecodeerde patch in de backend. Zie IHR-129 en IHR-127.
       *
       * Een ondergrens blijft wel nodig. Begint de verlenging op of voor de
       * startdatum van het contract dat verlengd wordt, dan krijgt NMBRS twee
       * perioden die over elkaar heen liggen, en dat kunnen wij niet terugdraaien.
       */
      vroegsteStartdatum() {
        return berekenVroegsteStartdatum(this.contractData.job_function
          ? this.contractData.job_function.start_date_old
          : null);
      },
      /*
       * Sluit de ingevulde startdatum aan op het vorige contract? Zo niet, dan is dat
       * een waarschuwing en geen blokkade: niet aansluiten is precies wat een
       * correctie doet.
       */
      startdatumSluitNietAan() {
        const jobFunction = this.contractData.job_function;
        if(!jobFunction) return false;
        return !startdatumSluitAan(jobFunction.start_date, jobFunction.fixed_term_expiration_date_old);
      },
      vorigeEinddatum() {
        const eind = this.contractData.job_function ? this.contractData.job_function.fixed_term_expiration_date_old : null;
        return eind ? moment(eind).format('DD-MM-YYYY') : '';
      },
    },
    data() {
      return{
        isSaving: false,
        editSchedule: false,
        editFunction: false,
        editSalary: false,
        editCompensations: false,
        isEditing: false,
        facOnly: false,
        currentContractStep: 1,
        maxContractStep: 2,
        templateHeader: "",
        templateFooter: "",
        countries: [],
        nationalities: [],
        templates: [],
        documentTypes: [],
        companyData: {},
        isEmployeeFillingInNAW: false,
        shouldGenerateContract: true,
        sendDirectlyToNMBRS: false,
        workHomeType: "none",
        weekdays: ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'],
        mail: { email_to: "", subject: "", email_body: "" },
        schedule: ['7.60','7.60','7.60','7.60','7.60','0','0','7.60','7.60','7.60','7.60','7.60','0','0'],
        dict: {},
        pellEditor: null
      }
    },
    methods: {
      isValid(e){
        let el = e.target ? e.target : e;
        let shouldShowvalidity = true;
        let validityCheck = true;
        if(e.target) this.refreshContract();
        if(el.dataset.field){
          validityCheck = el.dataset.field;
        }
        else if(el.parentElement.dataset.field){
          el = el.parentElement;
          validityCheck = el.dataset.field;
        }
        else if(el.parentElement.parentElement.dataset.field){
          el = el.parentElement.parentElement;
          validityCheck = el.dataset.field;
        }
        else if(el.tagName === "SELECT" && el.value === this.$t('form.select')){
          validityCheck = false;
        }
        else{
          switch(el.type){
            case "email":
              //eslint-disable-next-line
              validityCheck = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(el.value);
              break;
            case "tel":
              validityCheck = /^\+?\d{8,13}$/.test( el.value.replaceAll(" ", "").replaceAll("-", "") );
              break;
            case "number":
              validityCheck = /^[0-9,.]+$/.test(el.value);
              break;
            case "date":
              validityCheck = /^\d{4}-\d{2}-\d{2}$/.test(el.value);
              if(validityCheck && (el.hasAttribute('data-notinpast') || el.hasAttribute('data-notinfuture'))){
                const date = new Date(el.value);
                if(el.hasAttribute('data-notinpast'))
                  validityCheck = date > Date.now();
                else
                  validityCheck = date < Date.now();
              }
              if(validityCheck && isNaN(new Date(el.value).getTime())){
                validityCheck = false;
              }
              break;
            case "file":
              break;
            default: {
              switch(el.id){
                case "postal-code":
                  validityCheck = /^\d{4}\s?[a-zA-Z]{2}$/.test(el.value);
                  break;
                default:
                  validityCheck = el.value;
                  break;
              }
            }
          }
        }

        if(shouldShowvalidity)
          this.showValidity(el, validityCheck);
        return validityCheck;
      },
      validate(){
        const step = this.currentContractStep;
        const els = document.querySelectorAll(`#step-${step} input:not(.optional):not([type="radio"]), #step-${step} select:not(.optional), #step-${step} fieldset:not(.optional)`);
        let isValid = true;
        els.forEach(el => {
          if(!this.isValid(el)){
            isValid = false;
          }
        });
        if(!isValid){
          alert(this.$t('errors.empty_fields'));
        }
        if(this.contractData.job_function.start_date >= this.contractData.job_function.fixed_term_expiration_date && this.contractData.job_function.fixed_term){
          alert('De startdatum moet voor de einddatum liggen.');
          isValid = false;
        }
        // De ondergrens ook hier, want het min-attribuut van de browser houdt alleen
        // de datumkiezer tegen en niet een getypte of geplakte datum.
        const vorigeStart = this.contractData.job_function.start_date_old;
        const grens = berekenVroegsteStartdatum(vorigeStart);
        if(grens && this.contractData.job_function.start_date < grens){
          alert('De startdatum van de verlenging moet na de startdatum van het vorige contract liggen ('
            + moment(vorigeStart).format('DD-MM-YYYY') + ').');
          isValid = false;
        }
        return isValid;
      },
      setNext(){
        if(!this.validate()) return;
        if(this.currentContractStep == 1){
          this.$nextTick(this.$parent.initPell);
          this.setCustomTemplate();
          this.$parent.setDict();
          this.$parent.setTemplate();
        }
        this.currentContractStep++;

        window.scrollTo(0, 0);
      },
      setCustomTemplate(){
        const currentDate = moment().format("DD-MM-YYYY");
        const prevContractDate = moment(this.contractData.job_function.start_date_old).format("DD-MM-YYYY");
        const prevContractEndDate = this.contractData.job_function.fixed_term_expiration_date_old ? moment(this.contractData.job_function.fixed_term_expiration_date_old).format("DD-MM-YYYY") : currentDate;
        const contractEndDate = this.contractData.job_function.fixed_term_expiration_date ? moment(this.contractData.job_function.fixed_term_expiration_date).format("DD-MM-YYYY") : currentDate;
        let editorText = '';
        let theader = `De ondergetekenden: 

##werkgever_naam## 
##werkgever_adres## 
##werkgever_postcode## ##werkgever_plaats## 
 
hier vertegenwoordigd door ##werkgever_vertegenwoordiger_naam## 
hierna te noemen de "werkgever", 
 
en 
 
##werknemer_voorletters## ##werknemer_voorvoegsel## ##werknemer_achternaam##
##werknemer_straat## ##werknemer_huisnr## ##werknemer_toevoeg##
##werknemer_postcode## ##werknemer_plaats## 
Geboren op ##werknemer_geboortedatum## te ##werknemer_geboorteplaats##, ##werknemer_geboorteland##
hierna te noemen de "werknemer", 
 
VERKLAREN TE ZIJN OVEREENGEKOMEN ALS VOLGT:

Het huidige contract loopt af op ${prevContractEndDate} en wordt `;

        if(this.contractData.job_function.fixed_term && Number(this.contractData.job_function.fixed_term_expiration_month) > 0){
          theader += `verlengd met een contract voor bepaalde tijd van ${this.contractData.job_function.fixed_term_expiration_month} maanden, tot ${contractEndDate}.`;
        }
        else if(this.contractData.job_function.fixed_term && this.contractData.job_function.fixed_term_expiration_date){
          theader += `verlengd met een contract voor bepaalde tijd tot ${contractEndDate}.`;
        }
        else{
          theader += `omgezet in een contract voor onbepaalde tijd.`;
        }

        const changesText = this.setChangesText();
        if(changesText){
          theader += `

Daarnaast zal op de contractdatum het volgende worden aangepast:
${alsTekst(changesText)}`;
        }
        
        theader += `

Alle overige bepalingen van de arbeidsovereenkomst aangegaan op ${prevContractDate} blijven onverkort van kracht.

Wij verzoeken je deze verlenging voor akkoord te ondertekenen.

Wij danken je voor je inzet en kijken uit naar de voortzetting van onze prettige samenwerking.
`;
      const tfooter = `###nieuwe pagina###
Opgemaakt in tweevoud en getekend op ${currentDate}:

Handtekening werkgever
##werkgever_naam##

##handtekening_werkgever##

Handtekening werknemer
##werknemer_voornaam## ##werknemer_voorvoegsel## ##werknemer_achternaam##

##handtekening_werknemer##
`;
        this.$parent.setDict();
        this.templateHeader = this.$parent.decodeTemplate(theader);
        this.templateFooter = this.$parent.decodeTemplate(tfooter);
        this.$parent.templateHeader = editorText;
      },
      sendContractData(nextFormStep){
        if(!this.contractData.company_id){
          this.contractData.company_id = store.getters.getCurrentCompanyId;
        }
        if(nextFormStep == 'download'){
          this.contractData.no_sign_request = true;
          this.downloadPDF(this.contractData);
        }
        else{
          this.contractData.generate_date = moment().format("YYYY-MM-DD");
          if(!nextFormStep){
            this.nawData.contract = this.contractData;
          }
          const data = {...this.contractData};
          data.document = this.templateHeader + '<br/>' + data.document + '<br/>' + this.templateFooter;
          data.employee = {...this.nawData};
          data.external_id = this.nawData.external_id;
          if(data.job_function.employment_type == 'hourly' || data.job_function.employment_type == 'internship'){
            data.job_function.hours = 0;
          }
          if(!data.job_function.fixed_term){
            data.job_function.fixed_term_expiration_date = null;
          }
          //Validate email
          //eslint-disable-next-line
          if(!data.employee.email || !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(data.employee.email)){
            this.toastError("Het e-mailadres van deze medewerker (" + data.employee.email + ") is ongeldig. Pas het e-mailadres aan in het medewerkerprofiel voordat je het contract verzendt.");
            return;
          }
          data.send_sign_request = true;
          data.generate_contract = true;
          data.update_existing_employee = true;
          // Er gaat een contract ter ondertekening uit, dus de werkgever is aan
          // zet. Stond hier eerder hard op 1 ("in dienst") in saveSection, wat
          // het tegenovergestelde beweerde van wat er gebeurt; het ging alleen
          // goed doordat de backend er daarna overheen schreef. Blijft die
          // correctie ooit uit, dan ziet niemand dat er een handtekening
          // openstaat en gaat een annulering ongemerkt voorbij. Zie IHR-132.
          data.employee.employee_status_id = 4;
          // De rem ging er eerder in een finally weer af, dus ook na een
          // geslaagde opslag, terwijl de pagina dan nog niet weg is. Een klik in
          // dat gat verstuurde de verlenging een tweede keer. Nu blijft hij
          // erop na succes en gaat hij er alleen na een fout af.
          const verzoek = metRem(this, 'isSaving', () => contractService.updateNMBRS(store.getters.getCurrentCustomerId, data), { vasthoudenNaSucces: true });
          if(!verzoek) return;
          verzoek.then((response) => {
            // De backend kan melden dat iets niet of anders is doorgevoerd. Dat
            // moet de gebruiker lezen voordat de pagina weggaat; de rem blijft
            // er intussen op. Zie logic/meldingen.js.
            const waarschuwing = waarschuwingNaOpslaan(response);
            if(waarschuwing) alert(waarschuwing);
            window.location.href = window.location.origin + "/employees";
          }).catch(this.toastError);
        }
      },
      getListClass(step){
        const currentStep = this.currentContractStep;
        return step < currentStep ? "check" : (step == currentStep ? "active" : "inactive");
      },
      calculateTotalHours(e){
        let total = 0;
        this.schedule.forEach(hours => {
          const value = Number(hours);
          total += ((!hours || isNaN(value)) ? 0 : value);
        });
        total = total / 2;
        this.contractData.job_function.timetable = this.schedule.join(',');
        this.contractData.job_function.hours = total;
      },
      saveSection(section, nextFormStep){
        if(this.isSaving) return;
        if(!this.validate()) return;
        // De status wordt niet meer hier gezet: downloaden slaat niets op, en
        // bij opslaan hoort de werkgever aan zet te zijn. Dat gebeurt nu in
        // sendContractData, naast de vlaggen die aangeven dat er een contract
        // ter ondertekening uitgaat. Zie IHR-132.
        if(nextFormStep === 'download'){
          this.sendContractData(nextFormStep);
        }
        else{
          this.sendContractData('save');
        }
      },
      onContractBack(){
        this.currentContractStep--;
      },
      changeBack(field){
        if(field == 'editSchedule' && !this.editSchedule){
          const oudeJobFunction = this.$parent.oldContractData.job_function;
          this.contractData.job_function.employment_type = oudeJobFunction.employment_type;
          this.contractData.job_function.hours = oudeJobFunction.hours;
          this.contractData.job_function.timetable = oudeJobFunction.timetable;
          // De invoervelden moeten mee terug, anders draait calculateTotalHours()
          // hieronder het herstel meteen weer terug: die leest this.schedule en
          // schrijft dat over het zojuist herstelde timetable heen. Zie IHR-160.
          if(oudeJobFunction.timetable){
            this.schedule = String(oudeJobFunction.timetable).split(',');
          }
          this.calculateTotalHours();
        }
        if(field == 'editSalary' && !this.editSalary){
          this.contractData.job_function.salary = this.$parent.oldContractData.job_function.salary;
        }
        if(field == 'editFunction' && !this.editFunction){
          this.contractData.job_function.debtor_function_id = this.$parent.oldContractData.job_function.debtor_function_id;
          this.contractData.job_function.name = this.$parent.oldContractData.job_function.name;
          this.contractData.job_function.debtor_department_id = this.$parent.oldContractData.job_function.debtor_department_id;
          this.contractData.job_function.department = this.$parent.oldContractData.job_function.department;
        }
        if(field == 'editCompensations' && !this.editCompensations){
          this.contractData.job_function.travel_compensation_type = this.$parent.oldContractData.job_function.travel_compensation_type;
          this.contractData.job_function.travel_compensation = this.$parent.oldContractData.job_function.travel_compensation;
          this.contractData.job_function.work_days_at_home_compensation = this.$parent.oldContractData.job_function.work_days_at_home_compensation;
          this.contractData.job_function.total_work_days_at_home = this.$parent.oldContractData.job_function.total_work_days_at_home;
          this.contractData.job_function.expenses_compensation = this.$parent.oldContractData.job_function.expenses_compensation;
          this.contractData.job_function.phone_compensation = this.$parent.oldContractData.job_function.phone_compensation;
        }
      },
      setChangesText(){
        let changesString = "";
        const oldContractData = this.$parent.oldContractData;
        for(let field in oldContractData.job_function){
          const newVal = this.contractData.job_function[field];
          const oldVal = oldContractData.job_function[field];
          if(newVal != oldVal){
            if(field == 'employment_type'){
              changesString += "Het dienstverband wordt aangepast naar " + this.$t('employee.employment_type_' + newVal) + ".\n";
            }
            if(field == 'salary'){
              const newSalary = Number(newVal).toFixed(2).replace(',', '').replace('.', ',');
              const newPer = this.contractData.job_function.employment_type == 'hourly' ? ' per uur' : ' per maand';
              changesString += "Het salaris zal per die datum €" + newSalary + newPer + " bedragen.\n";
            }
            if(field == 'timetable'){
              // Niet het kale getal: de som van het rooster kan 31.999999999999996
              // zijn, en dit is een tekst die ondertekend wordt.
              changesString += "Je zult in dienst zijn voor " + urenAlsTekst(this.contractData.job_function.hours) + " uur per week.\n";
            }
            if(field == 'name'){
              const newText = document.getElementById("job-title").selectedOptions[0].text;
              changesString += "Je zult de functie krijgen van " + newText + ".\n";
            }
            if(field == 'department'){
              const newText = document.getElementById("department").selectedOptions[0].text;
              changesString += "Je zult de afdeling krijgen van " + newText + ".\n";
            }
            if(field == 'travel_compensation_type'){
              changesString += "Je ontvangt vanaf die datum een reiskostenvergoeding.\n";
            }
            if(field == 'work_days_at_home_compensation'){
              changesString += "Je ontvangt vanaf die datum een thuiswerkvergoeding.\n";
            }
            if(field == 'expenses_compensation'){
              changesString += "Je ontvangt vanaf die datum een onkostenvergoeding.\n";
            }
            if(field == 'phone_compensation'){
              changesString += "Je ontvangt vanaf die datum een telefoonkostenvergoeding.\n";
            }
            if(field == 'skilled_worker'){
              changesString += "Je zult worden aangemerkt als " + (this.contractData.job_function.skilled_worker ? "vakkracht" : "niet-vakkracht") + ".\n";
            }
          }
        }
        return changesString.trim();
      },
      calcTravelCompensation(){
        this.contractData.job_function.travel_compensation = Math.ceil(1.6407 * Number(this.contractData.job_function.travel_compensation_distance) * 
            Number(this.contractData.job_function.travel_compensation_days) * 100) / 100; // (((214 * 0.23) / 5) * 2) / 12) = 1.6407
      },
      calcWorkHomeCompensation(){
        this.contractData.job_function.work_days_at_home_compensation = (214 * 2.15 * Number(this.contractData.job_function.total_work_days_at_home)) / 12;
      },
      setWorkHomeCompensation(hasComp){
        this.contractData.job_function.has_wage_tax_credit = hasComp;
        this.contractData.job_function.total_work_days_at_home = null;
        this.contractData.job_function.work_days_at_home_compensation = null;
      },
      showValidity(el, isValid, showCheckmark = false){
        if(isValid){
          if(showCheckmark)
            el.classList.add('is-valid');
          el.classList.remove('is-invalid');
        }
        else{
          if(showCheckmark)
            el.classList.remove('is-valid');
          el.classList.add('is-invalid');
        }
      },
      refreshContract(){
        this.shouldGenerateContract = true;
      },
      getCompany(){
        const name = store.getters.getCurrentCompanyName;
        if(!name){
          const el = document.getElementById('company-select');
          if(!el || el.selectedIndex === -1) return '-';
          return el.options[el.selectedIndex].innerHTML;
        }
        return name;
      },
      getHoursCleaned(value){
        const rvalue = value.toFixed(2).replace('.', ',').replace(',00', '');
        return rvalue[rvalue.length - 1] === '0' && rvalue.includes(',') ? rvalue.slice(0, -1): rvalue;
      },
      /*
       * Een gewijzigde startdatum moet de einddatum meenemen zolang er een looptijd
       * in maanden gekozen is; dat veld is dan immers niet zelf invulbaar.
       */
      startdatumGewijzigd(e){
        if(Number(this.contractData.job_function.fixed_term_expiration_month) > 0){
          this.setContractEndTime();
        }
        this.isValid(e);
      },
      setContractEndTime(){
        const startDate = this.contractData.job_function.start_date;
        if(!startDate) return;

        const months = this.contractData.job_function.fixed_term_expiration_month;
        this.contractData.job_function.fixed_term_expiration_date = moment(this.contractData.job_function.start_date).add(months, 'M').subtract(1, "days").format('YYYY-MM-DD');
      },
      downloadPDF(item) {
        this.item = {...item};
        this.item.document = this.templateHeader + '<br/>' + this.item.document + '<br/>' + this.templateFooter;
        contractService.downloadDirect(this.item.document, store.getters.getCurrentCompanyId).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            const companyName = this.getCompany().replaceAll(' ', '-');
            const pdfName = companyName + "_" + item.employee.first_name.replace(' ', '-') + '_' + item.employee.last_name.replace(' ', '-') + "_verlenging";
            link.setAttribute("download", pdfName + ".pdf");
            document.body.appendChild(link);
            link.click();
        }).catch(this.toastError);
      }
    }
  }
</script>